import { styles } from './template.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as fonts } from '../../../../assets/fonts.scss';
import { LabelWidthValues } from '../../../../types/common/types';

export const templateMiscellaneousForm = document.createElement('template');
templateMiscellaneousForm.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${fonts}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='form-wrapper' id='package-miscellaneous-form-wrapper'>
    <div class='form-section'>
      <gz-accordion  id='miscellaneous-section' removeTitlePadding customTitleFontSize='11' removeContentPadding>
        <gz-form-field id='module-submit-crash-dumps' class='flex-group'>
            <gz-checkbox class='form-field-input-misc-accordion' checked gz-form-input></gz-checkbox>
        </gz-form-field>

        <div id='submit-quarantine-section' class='flex-group'>
            <gz-form-field id='module-submit-quarantine'>
                <gz-checkbox class='form-field-input-misc-accordion' checked gz-form-input></gz-checkbox>
            </gz-form-field>
            <gz-form-field id='module-submit-quarantine-hours' class='submit-quarantine-hours-dropdown' label='' required>
                <gz-dropdown gz-form-input type='dropdown' labelWidth='${LabelWidthValues.SMALL}' ></gz-dropdown>
                <gz-input-error></gz-input-error>
            </gz-form-field>
        </div>

        <gz-form-field id='module-submit-suspicious' class='flex-group'>
            <gz-checkbox class='form-field-input-misc-accordion' checked gz-form-input></gz-checkbox>
        </gz-form-field>

        <gz-form-field id='module-submit-endpoint-health-feedback' class='flex-group'>
            <gz-checkbox class='form-field-input-misc-accordion' checked gz-form-input></gz-checkbox>
            <gz-info-box id='module-submit-endpoint-health-feedback-warning' severity='warning' class='hidden'></gz-info-box>
        </gz-form-field>

        <gz-form-field id='module-use-global-protective-network' class='flex-group'>
            <gz-checkbox class='form-field-input-misc-accordion' checked gz-form-input></gz-checkbox>
            <gz-info-box id='module-use-global-protective-network-warning' severity='warning' class='hidden'></gz-info-box>
        </gz-form-field>
      </gz-accordion>
    </div>
  </div>
`;
